import ngFilter from 'angular-filter';
import {
  splitFilter,
  splitNestedByNewlineFilter,
  startFrom,
  formatIban
} from '@fino/lib-data-filter';
import { DataParser } from './parser';

export default angular
  .module('ng1-filter', [ngFilter])
  .filter('split', splitFilter)
  .filter('splitByNewline', splitNestedByNewlineFilter)
  .filter('iban', formatIban)
  .filter('startFrom', startFrom)
  .filter('unsafe', ($sce) => { 'ngInject'; return $sce.trustAsHtml; })
  .filter('format', DataParser.createFilter)
  .service('dataParser', DataParser)
  .name;
